import React from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    IconButton,
    Box,
    Button,
    Typography,
    Divider,
    Grid,
    Chip,
    Stack,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";


export default function BrandUseAndCreativeGuidelinesProtocol({
    open,
    onClose,
    markaUnvan = "",
    markaMersisVno = "",
    markaAdres = "",
    markaTemsilciAdSoyad = "",
    markaEposta = "",
    markaTel = "",
}) {
    const Section = ({ title, children, id }) => (
        <Box id={id} sx={{ mt: 3 }}>
            <Typography variant="h6" fontWeight={700} gutterBottom>
                {title}
            </Typography>
            <Divider sx={{ mb: 2 }} />
            <Box>{children}</Box>
        </Box>
    );

    const InfoRow = ({ label, value }) => (
        <Grid container spacing={1} sx={{ mb: 0.5 }}>
            <Grid item xs={4} sm={3} md={2}>
                <Typography variant="body2" color="text.secondary">
                    {label}
                </Typography>
            </Grid>
            <Grid item xs={8} sm={9} md={10}>
                <Typography variant="body2">{value}</Typography>
            </Grid>
        </Grid>
    );

    return (
        <Dialog
            open={open}
            onClose={onClose}
            fullWidth
            maxWidth="md"
            scroll="paper"
            PaperProps={{ sx: { borderRadius: 4, p: 0.5 } }}
        >
            <DialogTitle sx={{ display: "flex", alignItems: "center", pr: 6 }}>
                <Stack direction="row" spacing={1} alignItems="center">
                    <Typography variant="h5" fontWeight={800}>Marka Kullanım ve Kreatif Rehber Protokolü</Typography>
                    <Chip size="small" label={(new Date()).toLocaleDateString("tr-TR")} />
                </Stack>
                <IconButton aria-label="Kapat" onClick={onClose} sx={{ position: "absolute", right: 12, top: 12 }}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>

            <DialogContent dividers>
                {/* Taraflar */}
                <Section title="Taraflar" id="taraflar">
                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Alcago</Typography>
                    <Box sx={{ mb: 2 }}>
                        <InfoRow label="Unvan" value='Alcago Teknoloji Anonim Şirketi ("Alcago")' />
                        <InfoRow label="MERSİS" value="0050117816000001" />
                        <InfoRow label="Adres" value="İdealtepe Mah. Denizciler Cad. No: 22 İç Kapı No: 4, Maltepe / İstanbul" />
                        <InfoRow label="E-posta" value="destek@alcago.com" />
                        <InfoRow label="Telefon" value="0539 397 13 63" />
                    </Box>

                    <Typography variant="subtitle1" fontWeight={700} sx={{ mb: 1 }}>Marka</Typography>
                    <Box>
                        <InfoRow label="Unvan" value={`${markaUnvan} ("Marka")`} />
                        <InfoRow label="MERSİS/Vergi No" value={markaMersisVno} />
                        <InfoRow label="Adres" value={markaAdres} />
                        <InfoRow label="Temsilci" value={markaTemsilciAdSoyad} />
                        <InfoRow label="E-posta" value={markaEposta} />
                        <InfoRow label="Telefon" value={markaTel} />
                    </Box>
                </Section>

                {/* 1. Amaç */}
                <Section title="1. Amaç" id="amac">
                    <Typography>
                        İşbu Protokol; Markanın logo, marka, ticari unvan, ürün görselleri, kampanya materyalleri ve reklam içeriklerinin Alcago tarafından dijital platformlarda (mobil uygulama, web sitesi, panel, sosyal medya ve iş ortakları) kullanılmasına ilişkin usul ve esasları belirler.
                    </Typography>
                </Section>

                {/* 2. Tanımlar */}
                <Section title="2. Tanımlar" id="tanimlar">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li><strong>İçerik:</strong> Logo, ürün fotoğrafı, video, reklam filmi, kampanya materyali, metin ve grafik tasarımlar.</li>
                        <li><strong>Lisans:</strong> Markanın Alcago’ya verdiği, içerikleri belirlenen sınırlar dahilinde kullanma hakkı.</li>
                        <li><strong>Kreatif Rehber:</strong> Alcago’nun yayın standartlarını düzenleyen kurallar bütünü.</li>
                    </ul>
                </Section>

                {/* 3. Marka’nın Sağladığı İçerikler */}
                <Section title="3. Marka’nın Sağladığı İçerikler" id="icerikler">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Marka, kampanyalarda kullanılmak üzere gerekli içerikleri (logo, görsel, ürün açıklamaları, indirim kodu vb.) eksiksiz ve doğru şekilde sağlar.</li>
                        <li>İçeriklerin doğru, güncel, hukuka uygun ve üçüncü kişi haklarını ihlal etmediğini garanti eder.</li>
                        <li>İçeriklerin kullanımına ilişkin gerekli izin ve hakların kendisine ait olduğunu taahhüt eder.</li>
                    </ul>
                </Section>

                {/* 4. Alcago’nun Kullanım Hakkı */}
                <Section title="4. Alcago’nun Kullanım Hakkı" id="kullanim-hakki">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Marka, içeriklerini münhasır olmayan, Türkiye ile sınırlı ve kampanya süresiyle sınırlı olmak üzere Alcago’ya ücretsiz lisanslar.</li>
                        <li>Alcago, içerikleri yalnızca platformunda, sosyal medya hesaplarında ve iş ortaklarıyla yürüttüğü reklam faaliyetlerinde kullanabilir.</li>
                        <li>Alcago, içerik üzerinde değişiklik yapmaz; yalnızca interaktif katman (oyunlaştırma, baloncuk, anket sorusu vb.) ekleyebilir.</li>
                    </ul>
                </Section>

                {/* 5. Kullanım Sınırları */}
                <Section title="5. Kullanım Sınırları" id="sinirlar">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>İçerikler yalnızca sözleşme süresince ve kampanya kapsamında kullanılır.</li>
                        <li>İçerikler Markanın itibarını zedeleyici veya yanıltıcı şekilde kullanılamaz.</li>
                        <li>Lisans devredilemez, alt lisans verilemez; ancak ifa için alt yükleniciler (influencer ajansları, yayıncılar) tarafından kullanılabilir.</li>
                    </ul>
                </Section>

                {/* 6. Kreatif Standartlar */}
                <Section title="6. Kreatif Standartlar" id="standartlar">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>İçerikler RTÜK, Reklam Kurulu ve Ticaret Bakanlığı düzenlemelerine uygun olmalıdır.</li>
                        <li>Yasadışı bahis, alkol, tütün, müstehcenlik, şiddet veya yanıltıcı sağlık beyanı içeren reklamlar yasaktır.</li>
                        <li>Alcago, bu kriterlere aykırı içerikleri gerekçesiz olarak reddedebilir veya yayından kaldırabilir.</li>
                    </ul>
                </Section>

                {/* 7. Fikri Mülkiyet Hakları */}
                <Section title="7. Fikri Mülkiyet Hakları" id="fmh">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Marka, içeriklerin tüm fikri mülkiyet haklarının kendisine ait olduğunu taahhüt eder.</li>
                        <li>Üçüncü kişilerin telif, marka veya diğer haklarının ihlali halinde sorumluluk Marka’ya aittir.</li>
                        <li>Alcago’nun yazılım, panel, veri tabanı ve oyunlaştırma teknolojisi üzerindeki tüm hakları Alcago’ya aittir.</li>
                    </ul>
                </Section>

                {/* 8. Sorumluluk ve Tazminat */}
                <Section title="8. Sorumluluk ve Tazminat" id="tazminat">
                    <Typography>
                        Marka, sağladığı içeriklerin hukuka aykırı olması veya üçüncü kişilerin haklarını ihlal etmesi nedeniyle doğabilecek her türlü idari para cezası, dava, tazminat ve masraftan sorumludur; Alcago’nun bu sebeple uğrayacağı zararları derhal tazmin eder.
                    </Typography>
                </Section>

                {/* 9. Süre ve Fesih */}
                <Section title="9. Süre ve Fesih" id="sure-fesih">
                    <ul style={{ margin: 0, paddingLeft: 18 }}>
                        <li>Protokol, ana hizmet sözleşmesi süresince yürürlüktedir.</li>
                        <li>İçerikleri kullanma izni, ilgili kampanya süresi bitince kendiliğinden sona erer.</li>
                        <li>Taraflar, 30 gün önceden bildirimle feshedebilir.</li>
                    </ul>
                </Section>

                {/* 10. Hukuk ve Yetki */}
                <Section title="10. Hukuk ve Yetki" id="hukuk-yetki">
                    <Typography>Türk hukuku uygulanır; İstanbul (Çağlayan) Merkez Mahkemeleri ve İcra Daireleri yetkilidir.</Typography>
                </Section>

                {/* 11. Elektronik Onay */}
                <Section title="11. Elektronik Onay" id="e-onay">
                    <Typography>Taraflar, bu Protokolü elektronik ortamda onaylayarak yürürlüğe koymuş sayılır.</Typography>
                </Section>

                <Box sx={{ mt: 3, display: "flex", justifyContent: "flex-end", gap: 1 }}>
                    <Button variant="outlined" onClick={onClose}>Kapat</Button>
                </Box>
            </DialogContent>
        </Dialog>
    );
}
